import { render, staticRenderFns } from "./NavHelpCentreEn.vue?vue&type=template&id=08f8e1da"
import script from "./NavHelpCentreEn.vue?vue&type=script&lang=ts"
export * from "./NavHelpCentreEn.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NavButton: require('/app/components/rebrand-header/NavButton.vue').default,NavHelpCentreItem: require('/app/components/rebrand-header/NavHelpCentreItem.vue').default,NavMenu: require('/app/components/rebrand-header/NavMenu.vue').default})
